import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/postcss/lib/postcss.js";
import "../node_modules/postcss-js/index.js";
import "../node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const only = objectWithClassName({
  className: "sr-only",
  clip: "rect(0,0,0,0)",
  borderWidth: "0px",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: "0",
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
});
export {
  only
};
//# sourceMappingURL=screen-reader.js.map
